/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ current: NonNullable<unknown>, total: NonNullable<unknown> }} Gallery_View_ImageInputs */

const en_gallery_view_image = /** @type {(inputs: Gallery_View_ImageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`View image ${i?.current} of ${i?.total}`)
};

const ar_gallery_view_image = /** @type {(inputs: Gallery_View_ImageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`عرض الصورة ${i?.current} من ${i?.total}`)
};

const bn_gallery_view_image = /** @type {(inputs: Gallery_View_ImageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.total}-এর মধ্যে ${i?.current} নম্বর ইমেজ দেখুন`)
};

const de_gallery_view_image = /** @type {(inputs: Gallery_View_ImageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bild ${i?.current} von ${i?.total} ansehen`)
};

const es_gallery_view_image = /** @type {(inputs: Gallery_View_ImageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ver imagen ${i?.current} de ${i?.total}`)
};

const fr_gallery_view_image = /** @type {(inputs: Gallery_View_ImageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Voir l'image ${i?.current} sur ${i?.total}`)
};

const pt_gallery_view_image = /** @type {(inputs: Gallery_View_ImageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ver imagem ${i?.current} de ${i?.total}`)
};

const zh_gallery_view_image = /** @type {(inputs: Gallery_View_ImageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`查看图片 ${i?.current}（共 ${i?.total}）`)
};

const tr_gallery_view_image = /** @type {(inputs: Gallery_View_ImageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.total} resminin ${i?.current} resmini görüntüle`)
};

const ru_gallery_view_image = /** @type {(inputs: Gallery_View_ImageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Просмотреть изображение ${i?.current} из ${i?.total}`)
};

const pl_gallery_view_image = /** @type {(inputs: Gallery_View_ImageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zobacz obraz ${i?.current} z ${i?.total}`)
};

/**
* | output |
* | --- |
* | "View image {current} of {total}" |
*
* @param {Gallery_View_ImageInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const gallery_view_image = /** @type {((inputs: Gallery_View_ImageInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gallery_View_ImageInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_gallery_view_image(inputs)
	if (locale === "bn") return bn_gallery_view_image(inputs)
	if (locale === "de") return de_gallery_view_image(inputs)
	if (locale === "es") return es_gallery_view_image(inputs)
	if (locale === "fr") return fr_gallery_view_image(inputs)
	if (locale === "pt") return pt_gallery_view_image(inputs)
	if (locale === "zh") return zh_gallery_view_image(inputs)
	if (locale === "tr") return tr_gallery_view_image(inputs)
	if (locale === "ru") return ru_gallery_view_image(inputs)
	if (locale === "pl") return pl_gallery_view_image(inputs)
	return en_gallery_view_image(inputs)
});